module.exports = __webpack_public_path__ + "img/Zugführer.8ecf1db7.svg";